import { Component, ViewChild, AfterViewInit, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatPaginatorModule,MatPaginator } from '@angular/material/paginator'; 
import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { ShareOptionComponent } from '../../tools/share-option/share-option/share-option.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FacadeService } from '../../services/facade.service';
import { ProyectosService } from '../../services/proyectos.service';

import { ProjectRemoveComponent } from '../../tools/project-remove/project-remove.component';

import { ListRemoveComponent } from '../../tools/list-remove/list-remove.component';
import { WordlistComponent } from '../../tools/wordlist/wordlist.component';
import { AppComponent } from '../../app.component';

interface Project {
  name: string;
  wordCount: number;
  sections: number;
  date: Date;
}

interface WordList {
  name: string;
  wordCount: number;
  date: Date;
}

@Component({
  selector: 'dashboard',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    MatTableModule,
    MatDialogModule,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    MatPaginatorModule,
    ShareOptionComponent,
    HttpClientModule,
    ProjectRemoveComponent 

  ],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']  // Corrección aquí
})
export class DashboardComponent implements OnInit{

  loaderActive: boolean;

  displayedColumns: string[] = ['name', 'sections', 'date', 'actions'];
  projects = new MatTableDataSource([
  ]);

  displayedColumnsWordList: string[] = ['name', 'wordCount', 'date', 'actions'];
  wordLists = new MatTableDataSource<WordList>([
  ]);
  currentPageProjects = 1;
  currentPageWordLists = 1;
  itemsPerPage = 10; // Cambiado a 10 elementos por página
  paginatedProjects = new MatTableDataSource<Project>();
  paginatedWordLists = new MatTableDataSource<WordList>();
  pagesProjects: number[] = [];
  pagesWordLists: number[] = [];
  maxPagesToShow = 5; // Número máximo de páginas a mostrar en el paginador

  isThereManyProjects: boolean = true;
 
 

  async editProject(project) {
    await this.proyectoService.getinfo(this.http, project.id_project);
    window.location.reload();
    
    // setTimeout(() => {
    // }, 500);

    // this.proyectoService.getinfo(this.http, project.id_project, localStorage.getItem("text-inspector-django-token"));
    // setTimeout(() => {
    //   this.appComponent.checkTextUID();
    //   this.appComponent.showModalProyect();
    // }, 1000);
    // this.appComponent.editProyect();
    
    // selectMenuItem
    // lógica para editar el proyecto
  }
  

  async editWordList(list: any) {
    try {
      // Realizar la petición y obtener todas las listas
      let respuesta2 = await this.fachada.getAllwordlists(
        this.http,
        localStorage.getItem("text-inspector-django-token")
      );
  
      // Encontrar el objeto con el ID correspondiente
      const selectedList = respuesta2.find((item: any) => item.id === list.id);
  
      if (!selectedList) {
        console.error('No se encontró una lista con el ID proporcionado:', list.id);
        return;
      }
  
      // Pasar los datos al componente WordlistComponent
      const dialogRef = this.dialog.open(WordlistComponent, {
        data: {
          isEditing: true, // Indicador de que es modo edición
          id: selectedList.id,
          wordlist: selectedList.listado, // Lista de palabras
          name: selectedList.nombre,     // Opcional: agregar más datos si es necesario
        },
        backdropClass: 'dialog-backdrop-dark', // Fondo oscuro para este diálogo
      });
  
      // Manejar el resultado del diálogo
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
            sessionStorage.removeItem('data_wordlist');
    sessionStorage.removeItem('analysis_op');
        }
      });
    } catch (error) {
      console.error('Error al editar la Wordlist:', error);
    }
  }
  


  updatePaginationProjects() {
    const start = (this.currentPageProjects - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.paginatedProjects.data = this.projects.data.slice(start, end);
    const totalPages = Math.ceil(this.projects.data.length / this.itemsPerPage);
    const startPage = Math.max(1, this.currentPageProjects - Math.floor(this.maxPagesToShow / 2));
    const endPage = Math.min(totalPages, startPage + this.maxPagesToShow - 1);

    if(totalPages === 0){
      this.pagesProjects = [1];
    }else{
      this.pagesProjects = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
    }
  }

  updatePaginationWordLists() {
    const start = (this.currentPageWordLists - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.paginatedWordLists.data = this.wordLists.data.slice(start, end);
    const totalPages = Math.ceil(this.wordLists.data.length / this.itemsPerPage);
    const startPage = Math.max(1, this.currentPageWordLists - Math.floor(this.maxPagesToShow / 2));
    const endPage = Math.min(totalPages, startPage + this.maxPagesToShow - 1);
    if(totalPages === 0){
      this.pagesWordLists = [1];
    }else{
      this.pagesWordLists = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
    }
    
  }
  
  constructor( public dialog: MatDialog,
  private http: HttpClient,
  public fachada: FacadeService,
  public proyectoService: ProyectosService,
  public appComponent:AppComponent
) {

  }


  ngOnInit() {
    localStorage.setItem("actual","dashboard")
    this.initdashboard();
    this.checkProjects();
    setTimeout(() => {
      this.updatePaginationProjects();
    this.updatePaginationWordLists();
    }, 200);
    
  }

  initSubscribe() {
    //Subscribimos al servicio para escuchar los datos
    // this.proyectoService.proyecto$.subscribe(({ proyecto, firstProject })=>{
    //   console.log("Update de data --Reporta: COCA / BNC--")
    //   // this.project_data = proyecto;
    //   // this.initMetadiscourse();
    // });
  }
  

  async initdashboard() {
    try {
      this.loaderActive = true;
      let respuesta = await this.fachada.getAllprojects(this.http,localStorage.getItem("text-inspector-django-token"))
      let respuesta2 = await this.fachada.getAllwordlists(this.http,localStorage.getItem("text-inspector-django-token"))
      const totalProyectos = respuesta.length;
      const totalWordLists = respuesta2.length;
      sessionStorage.setItem("Proyectos", totalProyectos)
      sessionStorage.setItem("WordLists", totalWordLists)
      const parsedWordlist = respuesta2;
      sessionStorage.setItem("data_wordlist", JSON.stringify(parsedWordlist));
      
      // console.log("PROYECTOS",JSON.stringify(respuesta))
      
        if(totalProyectos >= 10){
          this.isThereManyProjects = true;
          this.proyectoService.updateDisablelimitOfProjects(true);
        }else{
          this.isThereManyProjects = false;
          this.proyectoService.updateDisablelimitOfProjects(false);
        }

      //  Transformar los datos y agregar el conteo de palabras
      this.wordLists.data = respuesta2.map((list: any) => ({
        id:list.id,
        name: list.nombre,
        wordCount: list.listado.length, // Contar palabras
        date: list.creation,
      }));

      for (let index = 0; index < respuesta.length; index++) {
        let element = respuesta[index];
        if (element.name == null || element.name == "Document 1"){
          element.name = element.text_UID
        }

        const relatedCount = element.related_projects ? element.related_projects.length : 0;
        element.sections = relatedCount + 1;
      }
      this.projects.data = respuesta;
      this.updatePaginationProjects();
      this.updatePaginationWordLists();
    } catch (error) {
      console.log("Error al obtener datos del dahsboard")
      console.log(error)
    }finally{
      this.loaderActive = false;
    }

  }

   checkProjects(){
    let totalProyectos = Number(sessionStorage.getItem("Proyectos"));

      if (totalProyectos >= 10) {
          this.isThereManyProjects = true;
      }else{
          this.isThereManyProjects = false;
      }

  }
  
  createList(){
    const dialogRef = this.dialog.open(WordlistComponent, {
      data: { 
        isEditing: false, // Indicador de que es modo edición
      },
      backdropClass: 'dialog-backdrop-dark' // Fondo oscuro para este diálogo
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) { 
          sessionStorage.removeItem('data_wordlist');
    sessionStorage.removeItem('analysis_op');
        setTimeout(() => {
          this.initdashboard();
        }, 1000);
      }
    });
  }


  shareProject(project: any) {
    this.dialog.open(ShareOptionComponent, {
      data: { shareLink: 'https://textinspector.com/?project=way&connection=thread' },
      backdropClass: 'dialog-backdrop-dark' // Fondo oscuro para este diálogo
    });
  }

async deleteProject(project: any) {
  const dialogRef = this.dialog.open(ProjectRemoveComponent, {
    data: {},
    backdropClass: 'dialog-backdrop-dark'
  });

  dialogRef.afterClosed().subscribe(async result => {
    if (result) {
        const projectRaw = sessionStorage.getItem("analysis_op");
        const project2 = JSON.parse(projectRaw);

      if(projectRaw){
        // Si el proyecto eliminado es el activo, limpia datos
        if (project2.related_projects && Array.isArray(project2.related_projects)) {
          const match = project2.related_projects.some(p => 
          p.text_UID === project.textUID
          );
          if(match){  
            this.proyectoService.clearProjectData();
              this.proyectoService.checkDeleteSameProjectToStorage(true);
              sessionStorage.removeItem('data_wordlist');

          }
          else{
            this.proyectoService.checkDeleteSameProjectToStorage(false);
          }
        }

          // Si el proyecto eliminado es el activo, limpia datos
        if (sessionStorage.getItem("text_UID") === project.text_UID) {
          this.proyectoService.clearProjectData();
          this.proyectoService.checkDeleteSameProjectToStorage(true);
          sessionStorage.removeItem('data_wordlist');
          
        } else {
          this.proyectoService.checkDeleteSameProjectToStorage(false);
        }
    }
      // Guardar índice y copia del proyecto por si necesitamos restaurarlo
      const index = this.projects.data.findIndex(p => p.id_project === project.id_project);
      const removedProject = this.projects.data[index];

      // Eliminar visualmente de la tabla
      this.projects.data.splice(index, 1);
      this.updatePaginationProjects();
       let totalProyectos = Number(sessionStorage.getItem("Proyectos") || 0);
        sessionStorage.setItem("Proyectos", String(totalProyectos - 1));
        totalProyectos = Number(sessionStorage.getItem("Proyectos") || 0);
          if(totalProyectos >= 10){
          this.isThereManyProjects = true;
          this.proyectoService.updateDisablelimitOfProjects(true);
        }else{
          this.isThereManyProjects = false;
          this.proyectoService.updateDisablelimitOfProjects(false);
        }

      
       try {
        await this.proyectoService.setDeleteProyect(this.http, true, project.id_project, project.text_UID);

        // Solo si fue exitoso, actualiza el contador en sessionStorage
       
      } catch (error) {
        console.error("Error al eliminar el proyecto:", error);

        // Restaurar el proyecto visualmente si falla
        this.projects.data.splice(index, 0, removedProject);
        this.updatePaginationProjects();
      }
    }
  });
}


  deleteList(list: any) {

    const wordlists = JSON.parse(sessionStorage.getItem("data_wordlist") || "[]");
    const selectedList = wordlists.find((item: any) => item.id === list.id);

    const dialogRef = this.dialog.open(ListRemoveComponent, {
      data: { },
      backdropClass: 'dialog-backdrop-dark' // Fondo oscuro para este diálogo
    });

    const instance = dialogRef.componentInstance;

  if (selectedList && selectedList.proyectos && selectedList.proyectos.length > 0) {
    instance.errorMsg = `You cannot remove this Wordlist. It is linked to: ${selectedList.proyectos.join(', ')}`;
    instance.proyectos = selectedList.proyectos;
    return;
  }
     // Manejar el resultado del diálogo 
     dialogRef.afterClosed().subscribe(async result => { 
      if (result) { 
        // Eliminar del wordLists.data
        this.wordLists.data = this.wordLists.data.filter((item: any) => item.id !== list.id);

        // Actualizar sessionStorage sin el elemento eliminado
        const updatedWordlists = wordlists.filter(item => item.id !== list.id);
        sessionStorage.setItem("data_wordlist", JSON.stringify(updatedWordlists));

        // Actualizar paginación visual
        this.updatePaginationWordLists();

        

        dialogRef.close();
        try {
        await this.fachada.deleteWordlist(this.http,localStorage.getItem("text-inspector-django-token") , list.id); 

        let totalWordLists = Number(sessionStorage.getItem("WordLists") || 0);
        sessionStorage.setItem("WordLists", String(totalWordLists - 1));
      } catch (error) {
        console.error("Error al eliminar el wordlist:", error);
      }
        
      } 
    });
  }
 


  
  goToPageProjects(page: number) {
    this.currentPageProjects = page;
    this.updatePaginationProjects();
  }

  prevPageProjects() {
    if (this.currentPageProjects > 1) {
      this.currentPageProjects--;
      this.updatePaginationProjects();
    }
  }

  nextPageProjects() {
    if (this.currentPageProjects < Math.ceil(this.projects.data.length / this.itemsPerPage)) {
      this.currentPageProjects++;
      this.updatePaginationProjects();
    }
  }

  goToPageWordLists(page: number) {
    this.currentPageWordLists = page;
    this.updatePaginationWordLists();
  }

  prevPageWordLists() {
    if (this.currentPageWordLists > 1) {
      this.currentPageWordLists--;
      this.updatePaginationWordLists();
    }
  }

  nextPageWordLists() {
    if (this.currentPageWordLists < Math.ceil(this.wordLists.data.length / this.itemsPerPage)) {
      this.currentPageWordLists++;
      this.updatePaginationWordLists();
    }
  }

  newAnalysis(){
    const projects = sessionStorage.getItem("Proyectos");
    if (!projects) return;
    this.appComponent.isNewAnalysis();
  }
  
}


